/**
 *  动画hook 目前只有进入动画
 */

import { useStore } from 'useStore';
import { ref } from 'vue';
import log from 'app-lib-log';
import { debounce } from '@/utils/util';

// 动态解析 配置数据
export const useAnimate = (option = {}) => {
  let { isH5, animateConfig } = option || {};

  const items = ref(null); // 节点信息
  const idFlag = 'name_' + ('' + Math.random()).split('.')[1]; //唯一标识

  const isShow = ref(false);
  //   进入区域执行动画的阀值
  const enterAreaAnmate = 100;
  // let recordScope = {}

  let setGlobal = null;

  let { enableAnimate, animate } = animateConfig || {};

  const isAnimate = () => {
    if (enableAnimate === false || !animate || animate === 'none') return false;
    return true;
  };
  const className = ref([idFlag, isAnimate() ? 'ani-hidden' : ''].join(' ')); // 组合后的动画类

  console.log('animateConf', isAnimate(), animateConfig, className.value);

  let curentScope = null;
  const initNode = scope => {
    let _this = scope || this;
    curentScope = _this;
    return new Promise(resolve => {
      if (isH5) {
        // TODO APPBIR 后续扩展支持 --  临时过
        // 获取当前的节点信息
        const element = document.querySelector(`.${idFlag}`);
        if (!element) {
          return console.warn('节点未找到');
        }
        let node2 = _this.$refs[idFlag];
        const rect = element.getBoundingClientRect();
        console.warn('存在节点', node2, element, rect);
        items.value = {
          top: rect?.top,
          height: rect?.height,
          bottom: rect?.bottom,
        };

        return resolve();
      } else {
        if (typeof uni === 'undefined') return;
        const query = uni.createSelectorQuery();
        const node = query.select(`.${idFlag}`);

        if (!node) {
          console.warn('节点未找到');
          return resolve(items.value);
        } else {
          console.warn('存在节点', node);
        }

        uni
          .createSelectorQuery()
          .in(scope || _this)
          .select(`.${idFlag}`)
          .boundingClientRect()
          .exec(res => {
            let item = res?.[0];
            items.value = {
              top: item?.top,
              height: item?.height,
              bottom: item?.bottom,
            };
            if (!item) log.warn('获取不到动画节点', '注意作用域this需要是当需要支持的前动画组件');
            resolve(items.value);
          });
      }
    });
  };

  const initAnimate = async scope => {
    const { global, actions } = useStore(); // 全局属性
    setGlobal = debounce(actions.setGlobal, 10);
    // state.value.global = global.value // 全局属性
    actions.setGlobal('scollTop',0)
    state.value.global = global.value; // 全局属性
    // scope.global = global;
    if (!isAnimate()) return;
    if (!scope) return log.me('初始化必须传递作用域');
    // recordScope = scope
    await initNode(scope);
    await showAnimate();
  };

  const isInViewArea = async () => {
    let {
      scollTop,
      systemInfo: { viewHeight },
    } = state.value.global;
    
    await initNode(curentScope);
    
    let eleTop = items.value?.top;
    let isShowAnimate = 1 * scollTop + viewHeight - enterAreaAnmate > eleTop;
    log.mi('是否显示动画:', isShowAnimate, idFlag, {
      scollTop,
      viewHeight,
      enterAreaAnmate,
      eleTop,
    });
    return isShowAnimate;
  };

  const calcClass = () => {
    return isAnimate() ? `animate__animated ${animate}` : '';
  };

  const getAnimateStyle = () => {
    let { enableAnimate, animate, enableLoop, durationAnimate, delayAnimate } = animateConfig || {};
    if (isAnimate()) {
      return {
        'animation-iteration-count': enableLoop ? 'infinite' : 'unset',
        'animation-duration': durationAnimate ? `${durationAnimate}s` : '2s',
        'animation-delay': delayAnimate ? `${delayAnimate}` : 0,
      };
    }
    return {};
  };

  const animateStyle = getAnimateStyle();

  // 显示动画计算
  const showAnimate = async () => {
    if (isShow.value) return; // 已经动画 不需要再次动画
    if (!isAnimate()) return;
    let res = await isInViewArea();
    if (res) {
      isShow.value = true;
      className.value = [idFlag, calcClass()].join(' ');
    } // 目前显示过后就不在显示

    log.mi('样式类名', className.value);
    return className.value;
  };

  // 滚动统一处理处理
  const setAnimate = e => {
    setGlobal('scollTop', e.scrollTop.toFixed(0));
  };

  const state = ref({
    global: {scollTop:0},
    className,
    items,
    idFlag,
    isShow,
    animateStyle,
  });

  return { state, actions: { showAnimate, initAnimate, setAnimate, isAnimate } };
};
